<template>
  <div class="message-send-container pt-2 pl-2 pr-2 pb-1 position-relative" :class="{ 'new-chat': newChat }">
    <div v-if="invoices && invoices.length > 0" class="row invoice-row">
      <div class="col-12">
        <div class="message-invoices-container">
          <div v-for="(invoice, index) in invoices" :key="'invoice_tobe_uploaded_' + index" class="message-invoice">
            <div class="remove-invoice clickable" @click="removeInvoice(invoice)">
              <i class="fas fa-times-circle" style="font-size: 24px" />
            </div>

            <div class="message-invoice-item">
              <div class="invoice-logo">
                <img
                  :src="industry == 'cannabis' ? '/img/logos/icon-apex.svg' : '/img/logos/icon-bushel.svg'"
                  :alt="industry == 'cannabis' ? 'Apex Logo' : 'Bushel44 Logo'"
                />
              </div>

              <div class="message-invoice-content">
                <div class="message-invoice-name">
                  {{ invoice.name }}
                  <span v-if="invoice.order_data" class="text-small"> ({{ dateShortestLocalized(invoice.order_data.order_date) }}) </span>
                </div>
                <div class="message-invoice-link">
                  {{ displayNameForLink() }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="images && images.length > 0" class="row">
      <div class="col-12">
        <div class="message-image-container">
          <div v-for="(image, index) in images" :key="'image_tobe_uploaded_' + index" class="message-image">
            <div class="remove-image text-white clickable" @click="removeImage(image)">
              <i class="fas fa-times-circle" style="font-size: 24px" />
            </div>
            <img v-if="image && image.file" :src="image.file" class="rounded mr-2 mb-2 float-left" />
          </div>
        </div>
      </div>
    </div>

    <div v-if="addingImage" class="row cropper-row">
      <div class="col-12">
        <FreeImageCropper
          :disabled="disabled || loading || submitting"
          input-id="chat_image_upload"
          :file-url="null"
          :reset-image="true"
          :no-overlay="true"
          class="cropper-box"
          :tooltip-message="imageToolTipMessage()"
          :tooltip-id="'chat_image_upload_tooltip' + toolTipId"
          @file-added="imageAdded"
        />
      </div>
    </div>

    <div v-if="addingInvoice" class="row">
      <div class="col-12">
        <ChatSelectInvoice
          v-if="addingInvoice"
          :key="addingInvoiceKey"
          :invoices-available="invoicesAvailable"
          :invoices-loaded="invoicesLoaded"
          :loading-invoices="loadingInvoices"
          :adding-invoice="addingInvoice"
          :invoice-present="invoicePresent"
          class="chat-select-invoice"
          @invoice-selected="invoiceSelected"
          @close="closeAddingInvoice"
        />
      </div>
    </div>

    <input
      ref="newMessageInput"
      v-model="newMessage"
      type="text"
      name="message"
      :placeholder="placeholder"
      :disabled="loading || submitting || disabled"
      :loading="loading"
      class="form-control message-send-textarea"
      :class="error ? 'has-error' : ''"
      aria-label="Message"
      aria-describedby="message"
      :text-limit="textLimit"
      :maxlength="textLimit"
      @keydown="(key) => $emit('keydown', key)"
      @keydown.enter.prevent="triggerSendMessage"
    />

    <div v-if="showTextLimit" class="text-chat-length">{{ newMessage && newMessage.length ? newMessage.length : 0 }} / {{ textLimit }}</div>

    <div class="position-relative message-send-buttons mt-2 mb-2">
      <BushelBtn
        v-if="enabledLinkInvoice"
        variant="primary"
        :ripple-color="darkMode ? 'dark' : 'light'"
        :flat="addingInvoice ? false : true"
        class="float-left mr-1"
        :disabled="disabled || loading || submitting || invoicePresent || imagePresent || invoicesAvailable.length <= 0"
        :class="[disabled || loading || submitting || invoicePresent || imagePresent || invoicesAvailable.length <= 0 ? 'disabled' : null]"
        @click="triggerAddInvoice"
      >
        <i class="fas fa-file-invoice new-chat-icon" style="width: 25px" />
        <!-- <i class="bushel-icon bushel-26 bushel-pie-chart p-0 m-0" /> -->
        <span class="sr-only"> Link Order </span>
      </BushelBtn>

      <BushelBtn
        v-if="enabledLinkImageFile"
        variant="primary"
        :ripple-color="darkMode ? 'dark' : 'light'"
        :flat="addingImage ? false : true"
        class="float-left mr-1 btn-upload"
        :disabled="disabled || loading || submitting || imagePresent || invoicePresent"
        :class="[disabled || loading || submitting || imagePresent || invoicePresent ? 'disabled' : null]"
        @click="triggerAddImage"
      >
        <!-- <i class="fas fa-link new-chat-icon" /> -->
        <!-- <i class="fas fa-paperclip new-chat-icon" /> -->
        <i v-if="!useBushelImageIcon" class="far fa-file-image new-chat-icon" style="width: 25px" />
        <i v-if="useBushelImageIcon" class="bushel-icon bushel-26 bushel-chat-link p-0 m-0" style="width: 25px; height: 25px" />
      </BushelBtn>

      <!---
      <BushelEmojiSelector
        :enabled="enabledInsertEmoji"
        :disabled="disabled || loading || submitting"
        :class="[disabled || loading || submitting ? 'disabled' : null]"
        :close-on-select="true"
        :skins-selection="true"
        :search-enabled="true"
        :close-on-clickaway="true"
        :show-active="true"
        :ripple-color="darkMode ? 'dark' : 'light'"
        icon-class="new-chat-icon"
        class="float-left mr-1"
        icon-style="width: 25px;"
        @emojiUnicodeAdded="emojiUnicodeAdded"
        @emojiImgAdded="emojiImgAdded"
        @emojiTriggerClicked="emojiTriggerClicked"
      />-->

      <BushelBtn
        variant="success"
        :ripple-color="darkMode ? 'dark' : 'light'"
        flat
        class="float-right ml-1"
        :disabled="disabled || loading || submitting"
        :class="[disabled || loading || submitting ? 'disabled' : null]"
        @click="triggerSendMessage"
      >
        <i v-if="!useBushelSendIcon" class="fas fa-paper-plane fa-fw new-chat-icon" :class="{ 'faa-passing faa-slow animated ': submitting }" />
        <i v-if="useBushelSendIcon" class="bushel-icon bushel-2x new-chat-icon mr-0" :class="darkMode ? 'bushel-paperplane' : 'bushel-paperplane'" />
      </BushelBtn>
    </div>
    <div class="clearfix" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
// import BushelEmojiSelector from '@/components/common/forms/BushelEmojiSelector';
import ChatSelectInvoice from "@/components/chat/ChatSelectInvoice.vue";
import FreeImageCropper from "@/components/common/FreeImageCropper.vue";
import { humanFileSize, dateShortestLocalized } from "@/services/filters";

export default {
  name: "NewChatMessage",
  components: { ChatSelectInvoice, FreeImageCropper },
  props: {
    initialChatMessage: { type: String },
    disabled: { type: Boolean, default: false },
    submitting: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    submitted: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    placeholder: { type: String, default: "Message" },
    clearDialog: { type: Boolean, default: false },
    invoicesAvailable: {
      type: Array,
      default() {
        return [];
      },
    },
    invoicesLoaded: { type: Boolean, default: false },
    loadingInvoices: { type: Boolean, default: false },
    enabledLinkInvoice: { type: Boolean, default: true },
    enabledLinkImageFile: { type: Boolean, default: true },
    enabledInsertEmoji: { type: Boolean, default: true },
    darkMode: { type: Boolean, default: false },
    useBushelSendIcon: { type: Boolean, default: true },
    useBushelImageIcon: { type: Boolean, default: false },
    imageSizeLimit: { type: Number, default: 2100000 },
    toolTipId: { type: [Number, String], default: "single" },
    allowImageTooltip: { type: Boolean, default: true },
    textLimit: { type: Number, default: 500 },
    showTextLimit: { type: Boolean, default: true },
    newChat: { type: Boolean, default: false },
  },
  emits: ["sendMessage", "keydown"],
  data() {
    return {
      industry: APP_INDUSTRY,
      appName: APP_NAME,
      addingImage: false,
      newMessage: null,
      images: [],
      addingInvoice: false,
      invoices: [],
      addingInvoiceKey: 2021,
      imageSizeError: false,
    };
  },
  computed: {
    imagePresent() {
      if (this.images && this.images.length > 0) {
        return true;
      }
      return false;
    },
    invoicePresent() {
      if (this.invoices && this.invoices.length > 0) {
        return true;
      }
      return false;
    },
  },
  watch: {
    clearDialog(newVal, oldVal) {
      const self = this;
      if (newVal) {
        self.addingImage = false;
        self.newMessage = null;
        self.images = [];
        self.invoices = [];
        setTimeout(() => {
          self.focusMessage();
        }, 1);
      }
    },
  },
  created() {},
  mounted() {
    this.newMessage = this.initialChatMessage ? this.initialChatMessage : null;
    this.focusMessage();
  },
  beforeUnmount() {},
  methods: {
    humanFileSize,
    dateShortestLocalized,
    ...mapActions({
      setSnackbar: "ui/setSnackbar",
    }),
    triggerSendMessage() {
      this.addingImage = false;
      this.$emit("sendMessage", {
        message: this.newMessage,
        images: this.images,
        invoices: this.invoices,
      });
      this.focusMessage();
    },
    emojiUnicodeAdded(val) {
      if (this.newMessage) {
        this.newMessage = `${this.newMessage} ${val} `;
      } else {
        this.newMessage = `${val} `;
      }
      this.focusMessage();
    },
    emojiImgAdded(val) {
      //
    },
    triggerAddImage() {
      this.addingInvoice = false;
      this.addingImage = !this.addingImage;
    },
    imageAdded(image) {
      // Clear images becuase we allow only one image/attachment per message.
      if (this.imagePresent) {
        this.images = [];
      }
      this.imageSizeError = false;
      if (image.size > this.imageSizeLimit) {
        this.imageSizeError = true;
        this.setSnackbar({
          variant: "danger",
          title: "Error",
          message: `Image too large. Max file size is: ${this.humanFileSize(this.imageSizeLimit)}`,
        });
        return false;
      }
      this.images.push(image);
      this.addingImage = false;
      return true;
    },
    removeImage(image) {
      this.addingImage = false;
      this.images = this.images.filter((t) => t != image);
    },
    triggerAddInvoice() {
      this.addingImage = false;
      this.addingInvoiceKey += 1;
      this.addingInvoice = !this.addingInvoice;
    },
    invoiceSelected(invoice) {
      if (this.invoicePresent) {
        this.invoices = [];
      }
      // let exists = this.invoices.find((inv) => inv.id == invoice.id);
      // if (!exists) {
      this.invoices.push(invoice);
      // }
      this.addingInvoice = false;
    },
    removeInvoice(invoice) {
      this.addingInvoice = false;
      this.invoices = this.invoices.filter((inv) => inv.id != invoice.id);
    },
    closeAddingInvoice() {
      this.addingInvoice = false;
    },
    emojiTriggerClicked() {
      this.addingInvoice = false;
      this.addingImage = false;
    },
    imageToolTipMessage() {
      if (this.allowImageTooltip) {
        return `The max file size is: ${this.humanFileSize(this.imageSizeLimit)}`;
      }
      return null;
    },
    displayNameForLink() {
      return window.location.host;
      // return this.appName;
    },
    focusMessage() {
      this.$refs.newMessageInput.focus();
    },
  },
};
</script>

<style scoped>
:deep(#popper-container) {
  width: 87%;
  /*background: #eeeeee;*/
}
:deep(.new-chat-icon) {
  font-size: 1.6em;
}
:deep(label) {
  cursor: pointer;
}
:deep(.example-avatar) {
  border-radius: 5px;
}
:deep(.example-avatar .fa-cloud-upload-alt) {
  font-size: 34px;
}
:deep(.example-avatar .drop-title) {
  font-size: 16px;
}
</style>

<style lang="scss" scoped>
@import "@sass/_variables.scss";
@import "@sass/_mixins.scss";
.message-send-container {
  background: $newChatMessageBgColor;
  border: 2px solid $newChatMessageBorderColor;
  width: 100%;
  margin: 0.5em;
  width: auto;
  border-radius: 5px;
  &.new-chat {
    width: 96.5%;
  }
}
@media (min-width: map-get($grid-breakpoints, sm) + 1px) {
  .message-send-container {
    &.new-chat {
      position: absolute !important;
      bottom: 0;
      width: 96%;
    }
  }
}
@media (min-width: map-get($grid-breakpoints, lg) + 1px) {
  .message-send-container {
    &.new-chat {
      width: 97.5%;
    }
  }
}
.message-send-textarea {
  font-weight: 400;
  height: 45px;
  border-color: transparent;
}
.form-control.has-error {
  border-color: $newChatMessageBorderErrorColor;
}
.message-send-textarea.form-control:disabled {
  background: $newChatMessageBgDisabledColor;
  opacity: 0.8;
}
.chat-select-invoice {
  position: absolute;
  width: 94%;
  margin: 0 2%;
  bottom: 26px;
  left: 0;
}
.text-chat-length {
  text-align: right;
  float: right;
  font-size: 9px;
  text-color: $grey-300;
  margin: 0;
  position: absolute;
  top: 39px;
  right: 13px;
}
.cropper-box {
  cursor: default;
  position: absolute;
  width: 94%;
  margin: 0 2%;
  bottom: 26px;
  left: 0;
  border-radius: 5px;
  padding: 10px;
  background: $newChatMessageBgColor;
  border: 2px solid $newChatMessageBorderColor;
  &:after,
  &:before {
    top: 100%;
    left: 75px;
    border: solid transparent;
    content: "";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  &:after {
    border-color: rgba(136, 183, 213, 0);
    border-top-color: $newChatMessageBgColor;
    border-width: 15px;
    margin-left: -15px;
  }
  &:before {
    border-color: rgba(194, 225, 245, 0);
    border-top-color: $newChatMessageBorderColor;
    border-width: 18px;
    margin-left: -18px;
  }
}
.message-image-container {
  cursor: default;
  position: absolute;
  width: 94%;
  margin: 0 2%;
  bottom: 26px;
  left: 0;
  border-radius: 5px;
  padding: 10px;
  background: $newChatMessageBgColor;
  border: 2px solid $newChatMessageBorderColor;
  &:after,
  &:before {
    top: 100%;
    left: 75px;
    border: solid transparent;
    content: "";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  &:after {
    border-color: rgba(136, 183, 213, 0);
    border-top-color: $newChatMessageBgColor;
    border-width: 15px;
    margin-left: -15px;
  }
  &:before {
    border-color: rgba(194, 225, 245, 0);
    border-top-color: $newChatMessageBorderColor;
    border-width: 18px;
    margin-left: -18px;
  }
  .message-image {
    float: left;
    position: relative;
    @include transitions();
    .remove-image {
      position: absolute;
      opacity: 0;
      left: 4px;
      top: 4px;
      @include transitions();
    }
    img {
      width: 100%;
      max-width: 250px;
    }
    &:hover {
      .remove-image {
        opacity: 0.9;
      }
    }
  }
}
.invoice-row {
  .message-invoices-container {
    cursor: default;
    position: absolute;
    width: 94%;
    max-width: 400px;
    margin: 0 2%;
    bottom: 26px;
    left: 0;
    border-radius: 10px;
    padding: 10px;
    background: $newChatMessageBgColor;
    border: 2px solid $newChatMessageBorderColor;
    &:after,
    &:before {
      top: 100%;
      left: 30px;
      border: solid transparent;
      content: "";
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
    }
    &:after {
      border-color: rgba(136, 183, 213, 0);
      border-top-color: $newChatMessageBgColor;
      border-width: 15px;
      margin-left: -15px;
    }
    &:before {
      border-color: rgba(194, 225, 245, 0);
      border-top-color: $newChatMessageBorderColor;
      border-width: 18px;
      margin-left: -18px;
    }
    .message-invoice {
    }
    .remove-invoice {
      display: none;
      background: $white;
      position: absolute;
      top: 5px;
      left: 5px;
      border-radius: 50%;
      margin: 0;
      padding: 0;
      height: 20px;
      width: 20px;
      z-index: 1;
    }
    .message-invoice-item {
      width: 100%;
      position: relative;
      .invoice-logo {
        width: 50px;
        float: right;
        img {
          width: 100%;
          max-width: 40px;
          margin: 0;
          position: absolute;
          right: 0;
        }
      }
      .message-invoice-content {
        width: calc(100% - 50px);
        float: left;
        .message-invoice-name {
          font-weight: 600;
          color: $primary;
          font-size: 14px;
        }
        .message-invoice-link {
          color: $grey-400;
          font-size: 0.8em;
        }
      }
    }
    &:hover {
      .remove-invoice {
        display: block;
      }
    }
  }
}
</style>
